import React from 'react';
import ReactDOM from 'react-dom/client';

// Modular CSS architecture - main.css imports all foundation + components
import './styles/main.css';

// Main styles
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Auth (Dynamic.xyz)
import { DynamicProvider } from './auth';
import { ProfileProvider } from './contexts/ProfileContext';

// Neue Provider für modulare Architektur
import { FeatureProvider } from './features/FeatureProvider';
import { GameProvider } from './state/GameContext';
import { PhaseProvider } from './state/PhaseContext';
import { TestModeProvider } from './features/testMode/TestModeProvider';
import { NotificationProvider } from './components/notifications';
import { EventLogProvider } from './contexts';

// Globaler Error Handler für MetaMask-Fehler (Extension injiziert sich selbst)
// Muss BEIDE Event-Typen abfangen UND stopImmediatePropagation verwenden
// damit React's Error Overlay den Fehler nicht anzeigt
const ignoreMetaMaskError = (event) => {
  const msg = event.message || event.reason?.message || '';
  const stack = event.error?.stack || event.reason?.stack || '';
  if (msg.includes('MetaMask') || stack.includes('MetaMask') ||
      msg.includes('ethereum') || stack.includes('inpage.js')) {
    event.preventDefault();
    event.stopImmediatePropagation();
    console.warn('[Ignored] MetaMask extension error');
    return true;
  }
};
window.addEventListener('error', ignoreMetaMaskError, true);
window.addEventListener('unhandledrejection', ignoreMetaMaskError, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DynamicProvider>
    <ProfileProvider>
      <FeatureProvider>
        <GameProvider>
          <PhaseProvider>
            <TestModeProvider>
              <NotificationProvider>
                <EventLogProvider>
                  <App />
                </EventLogProvider>
              </NotificationProvider>
            </TestModeProvider>
          </PhaseProvider>
        </GameProvider>
      </FeatureProvider>
    </ProfileProvider>
  </DynamicProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
